/**
 * Permet de parser une URL de service en ses différents composants
 * @param urlenv
 * @returns
 */
export function parseServiceUrl(urlenv: string): {
    url: string
    username: string
    password: string
} {
    // Détection du schéma (http ou https)
    const scheme = urlenv.startsWith("https") ? "https" : "http"

    // Séparation de la partie authentification et de l'URL
    const [authPart, urlPart] = urlenv.split("@")
    const url = `${scheme}://${urlPart}`

    // Séparation des identifiants username et password
    const authDetails = authPart.split("//")[1]
    const [username, password] = authDetails.split(":")

    return { url, username, password }
}

/**
 * Formatte une date au format JJ/MM/AAAA
 * @param date - Date à formater (string ou Date). Si c'est une string, elle doit être au format ISO
 */
export function formatDate(date?: string | Date) {
    if (!date) return "-"

    let innerDate: Date
    if (typeof date === "string") innerDate = new Date(date)
    else innerDate = date

    const day = String(innerDate.getDate()).padStart(2, "0") // Récupère le jour et ajoute un zéro si nécessaire
    const month = String(innerDate.getMonth() + 1).padStart(2, "0") // Les mois sont basés sur zéro, donc +1
    const year = innerDate.getFullYear() // Récupère l'année

    return `${day}/${month}/${year}` // Construit la chaîne de date formatée
}

/**
 * Permet de formater un numéro de source selon sa longueur et son type
 * @param idsource - Numéro de la source
 * @param idtype - Type de compteur
 */
export function formatIdSource(idsource: string, idtype: string) {
    if (!idsource) return ""

    // aide: permet d'insérer un text à une position donnée dans un autre texte
    function insertString(str: string, newStr: string, position: number) {
        return str.slice(0, position) + newStr + str.slice(position)
    }

    let newStr = idsource

    if (!["pdl", "pce"].includes(idtype)) {
        return idsource
    }

    if (idsource && idsource.length === 14) {
        const format = "### ### ### ### ##"
        for (let i = 0; i < format.length; i++) {
            if (format[i] === " ") newStr = insertString(newStr, " ", i)
        }
    } else if (idsource && idsource.length === 8) {
        const format = "## ######"
        for (let i = 0; i < format.length; i++) {
            if (format[i] === " ") newStr = insertString(newStr, " ", i)
        }
    }
    return newStr
}

export function formatAddress(address: {
    street: string
    zipcode: string
    city: string
    country: string
}) {
    return [
        address.street,
        address.zipcode,
        address.city,
        address.country ?? "France",
    ]
        .filter(Boolean)
        .join(", ") // Filtre les valeurs falsy (undefined, null, etc.)
}
